import {BetLineWinIndividualWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetLineWinIndividualWPController";

export class CCTwoIndividualPController extends BetLineWinIndividualWPController {

    // game does not have individual/toggle win presentations
    protected hasWin(): boolean {
        return false;
    }
}